"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxInline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _CheckboxOption = require("./CheckboxOption");
/**
 * Inline checkbox option. For backwards compatibility only, use
 * CheckboxOption directly instead.
 *
 * @deprecated
 */
var CheckboxInline = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_CheckboxOption.CheckboxOption, (0, _extends2.default)({
    ref: ref
  }, props, {
    inline: true
  }));
});
exports.CheckboxInline = CheckboxInline;
CheckboxInline.displayName = 'CheckboxInline';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDaGVja2JveElubGluZSIsIlJlYWN0IiwiZm9yd2FyZFJlZiIsInByb3BzIiwicmVmIiwiZGlzcGxheU5hbWUiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9DaGVja2JveC9DaGVja2JveElubGluZS5qc3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgQ2hlY2tib3hPcHRpb24gfSBmcm9tICcuL0NoZWNrYm94T3B0aW9uJztcblxuLyoqXG4gKiBJbmxpbmUgY2hlY2tib3ggb3B0aW9uLiBGb3IgYmFja3dhcmRzIGNvbXBhdGliaWxpdHkgb25seSwgdXNlXG4gKiBDaGVja2JveE9wdGlvbiBkaXJlY3RseSBpbnN0ZWFkLlxuICpcbiAqIEBkZXByZWNhdGVkXG4gKi9cbmV4cG9ydCBjb25zdCBDaGVja2JveElubGluZSA9IFJlYWN0LmZvcndhcmRSZWYoKHByb3BzLCByZWYpID0+IChcbiAgPENoZWNrYm94T3B0aW9uIHJlZj17cmVmfSB7Li4ucHJvcHN9IGlubGluZSAvPlxuKSk7XG5cbkNoZWNrYm94SW5saW5lLmRpc3BsYXlOYW1lID0gJ0NoZWNrYm94SW5saW5lJztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTtBQUVBO0FBRUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ08sSUFBTUEsY0FBYyxnQkFBR0MsY0FBSyxDQUFDQyxVQUFVLENBQUMsVUFBQ0MsS0FBSyxFQUFFQyxHQUFHO0VBQUEsb0JBQ3hELDZCQUFDLDhCQUFjO0lBQUMsR0FBRyxFQUFFQTtFQUFJLEdBQUtELEtBQUs7SUFBRSxNQUFNO0VBQUEsR0FBRztBQUFBLENBQy9DLENBQUM7QUFBQztBQUVISCxjQUFjLENBQUNLLFdBQVcsR0FBRyxnQkFBZ0IifQ==